import {useParams} from 'react-router-dom'
import {useFocusHint} from '@/pages/room/ui/focus-hint'
import {useRoomPage} from '../model/useRoomPage'
import {RoomHeader} from './RoomHeader'
import {RoomPhaseContent} from './RoomPhaseContent'

/**
 * Room page with pre-join lobby and LiveKit integration.
 * Orchestrates connection state and delegates phase UI to RoomPhaseContent.
 */
export const RoomPage = () => {
  const {roomId} = useParams() as {roomId: string} // roomId is guaranteed by route /room/:roomId
  const {state, onJoin, onLeave} = useRoomPage({roomId})
  const {focusHintOpen, onFocusHintOpenChange, requestFocusHint} = useFocusHint()

  const inCall = state.phase === 'ready'

  return (
    <div className="flex h-svh flex-col overflow-y-auto">
      {!inCall && (
        <RoomHeader
          roomId={roomId}
          onLeave={onLeave}
          inCall={false}
          focusHintOpen={undefined}
          onFocusHintOpenChange={undefined}
        />
      )}
      <div className="flex min-h-0 flex-1 flex-col">
        <RoomPhaseContent
          state={state}
          onJoin={onJoin}
          onLeave={onLeave}
          onRequestFocusHint={requestFocusHint}
          roomId={roomId}
          focusHintOpen={focusHintOpen}
          onFocusHintOpenChange={onFocusHintOpenChange}
        />
      </div>
    </div>
  )
}
